module.exports = __webpack_public_path__ + "static/media/m_nose_turnedup.b3544969.png";